var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 3,
    width: 9,
    height: 6.5,
    rx: 1,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#A8A8A8",
    fill: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,7C3.223857,7,3,7.223858,3,7.5C3,7.776143,3.223857,8,3.5,8C3.5,8,3.5,7,3.5,7C3.5,7,3.5,7,3.5,7ZM3.505,8C3.781142,8,4.005,7.776143,4.005,7.5C4.005,7.223858,3.781142,7,3.505,7C3.505,7,3.505,8,3.505,8C3.505,8,3.505,8,3.505,8ZM3.5,8C3.5,8,3.505,8,3.505,8C3.505,8,3.505,7,3.505,7C3.505,7,3.5,7,3.5,7C3.5,7,3.5,8,3.5,8C3.5,8,3.5,8,3.5,8Z",
    fill: "#A8A8A8",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.421053,5C2.1885120000000002,5,2,5.223858,2,5.5C2,5.776143,2.1885120000000002,6,2.421053,6C2.421053,6,2.421053,5,2.421053,5C2.421053,5,2.421053,5,2.421053,5ZM9.578949999999999,6C9.81149,6,10,5.776143,10,5.5C10,5.223858,9.81149,5,9.578949999999999,5C9.578949999999999,5,9.578949999999999,6,9.578949999999999,6C9.578949999999999,6,9.578949999999999,6,9.578949999999999,6ZM2.421053,6C2.421053,6,9.578949999999999,6,9.578949999999999,6C9.578949999999999,6,9.578949999999999,5,9.578949999999999,5C9.578949999999999,5,2.421053,5,2.421053,5C2.421053,5,2.421053,6,2.421053,6C2.421053,6,2.421053,6,2.421053,6Z",
    fill: "#A8A8A8",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCard);
export default __webpack_public_path__ + "static/media/bankCard.3dcfd9a40f23fa55805b5481f35ef3ef.svg";
export { ForwardRef as ReactComponent };